
import { defineComponent, watch } from "vue";
import { disableBodyOverflow, enableBodyOverflow } from "../mixins";

export default defineComponent({
  name: "ConfirmationModal",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
    },
    confirmButtonText: {
      type: String,
      default: "sair",
    },
    cancelButtonText: {
      type: String,
      default: "cancelar",
    },
  },
  emits: ["confirm", "cancel"],
  setup(props, { emit }) {
    const confirm = () => {
      emit("confirm");
    };

    const cancel = () => {
      emit("cancel");
    };

    watch(
      () => props.isOpen,
      (value) => {
        if (value) {
          disableBodyOverflow();
        } else {
          enableBodyOverflow();
        }
      }
    );

    return {
      confirm,
      cancel,
    };
  },
});
